import axios from 'axios'
import { CommonDepartmentTypeResponse } from '@/api/services/common/department-type/common-department-type.dto'

class CommonDepartmentTypeService {
    async getDepartmentTypesActive(): Promise<CommonDepartmentTypeResponse[]> {
        const response = await axios.get<CommonDepartmentTypeResponse[]>(`/departmentTypes/active`)
        return response.data
    }
}

export const commonDepartmentTypeService = new CommonDepartmentTypeService()
